import { render, staticRenderFns } from "./localServe.vue?vue&type=template&id=950ffd0c&scoped=true&"
import script from "./localServe.vue?vue&type=script&lang=js&"
export * from "./localServe.vue?vue&type=script&lang=js&"
import style0 from "./localServe.vue?vue&type=style&index=0&id=950ffd0c&prod&lang=css&"
import style1 from "./localServe.vue?vue&type=style&index=1&id=950ffd0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950ffd0c",
  null
  
)

export default component.exports